import A from '@/gf/components/A'
import Layout from '@/gf/components/Layout'
import Link from '@/gf/components/LinkOld'
import Page from '@/gf/components/Page'
import Frame from '../components/Frame'

const breadcrumbs = {
  copy: 'Back to Dashboard',
  crumbs: [],
}

const NotFound = () => (
  <Frame breadcrumbs={breadcrumbs}>
    <Page title="Page Not Found">
      <Layout>
        <Layout.Section type="full">
          Sorry, looks like we&apos;ve sent you the wrong way. <Link to="/">Back to home.</Link>
        </Layout.Section>
      </Layout>
    </Page>
  </Frame>
)
const NotFoundUnauthenticated = () => (
  <Page title="Page Not Found">
    <Layout>
      <Layout.Section type="full">
        Sorry, looks like we&apos;ve sent you the wrong way. <A.T href="/">Back to home.</A.T>
      </Layout.Section>
    </Layout>
  </Page>
)

NotFound.Unauthenticated = NotFoundUnauthenticated
export default NotFound
